<template>
  <v-container
    id="contact"
    class="pa-0 grey lighten-3 flex-wrap align-start fill-height"
    fluid
    tag="section"
  >
    <iframe
      allowfullscreen
      frameborder="0"
      height="500"
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d91950.9381368081!2d2.062266031974535!3d43.929011710336496!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12adc2b17997b70b%3A0x406f69c2f3bf0e0!2sAlbi!5e0!3m2!1sfr!2sfr!4v1659965970111!5m2!1sfr!2sfr"
      style="border:0"
      width="100%"
    />

    <v-row
      class="ma-0"
      justify="center"
    >
      <v-col
        cols="12"
        md="4"
      >
        <h1 class="display-1 mb-8 font-weight-bold">
          Contact :
        </h1>

        <div class="mb-8">
          N'hésitez pas à m'envoyer un message pour toute information complémentaire.
        </div>

        <div class="mb-4">
          <strong>Adresse</strong> Albi
        </div>

        <div class="mb-4">
          <strong>Téléphone</strong> +33 (0)6.38.57.14.37
        </div>

        <div class="mb-4">
          <strong>Email</strong> astorgolga(arobase)gmail.com
        </div>
      </v-col>
      <v-col
        cols="12"
        md="5"
      >
        <v-form>
          <v-row class="mb-6">
            <v-col
              cols="12"
              md="6"
            >
              <v-sheet>
                <v-text-field
                  flat
                  hide-details
                  label="Nom"
                  solo
                />
              </v-sheet>
            </v-col>

            <v-col
              cols="12"
              md="6"
            >
              <v-sheet>
                <v-text-field
                  flat
                  hide-details
                  label="Adresse email"
                  solo
                />
              </v-sheet>
            </v-col>

            <v-col cols="12">
              <v-sheet>
                <v-text-field
                  flat
                  hide-details
                  label="Sujet"
                  solo
                />
              </v-sheet>
            </v-col>

            <v-col cols="12">
              <v-sheet>
                <v-textarea
                  flat
                  hide-details
                  label="Message [Work In Progess : envoyer les messages avec l'adresse email et non pas avec le formulaire]"
                  solo
                />
              </v-sheet>
            </v-col>
          </v-row>

          <v-btn
            :block="$vuetify.breakpoint.smAndDown"
            class="white--text"
            color="black"
            x-large
          >
            Envoyer le message
          </v-btn>
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'Contact',
  }
</script>
